/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function HistoriaHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
        {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-historia-mobile.png")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-historia-1024.jpg")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/historia-header.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default HistoriaHeader;